export enum AcknowledgeExpirationDateContainerEnum {
  NOTIFY_COLLABORATORS_CONTAINER = 'notify-collaborators-container',
}

export enum AcknowledgeExpirationDateSelectEnum {
  NOTIFY_COLLABORATORS_SELECT = 'notify-collaborators-select',
}
